import FallbackLoader from './FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-ConsentRequestModal" */'shared-components/components/ConsentRequestModal'));
